var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMarker(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "48px",
    height: "48px",
    viewBox: "0,0,256,256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: 24,
    y1: 45.057,
    x2: 24,
    y2: 22.031,
    gradientUnits: "userSpaceOnUse",
    id: "color-1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.791,
    stopColor: "#889097"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.858,
    stopColor: "#838c93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.937,
    stopColor: "#758089"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#64717c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 19.969,
    y1: 5.61,
    x2: 28.093,
    y2: 20.504,
    gradientUnits: "userSpaceOnUse",
    id: "color-2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f44f5a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.443,
    stopColor: "#ec2a38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e52030"
  })))), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(5.33333,5.33333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26,20h-4c0,0 0,19 0,21c0,2 2,4 2,4c0,0 2,-2 2,-4c0,-2 0,-21 0,-21z",
    fill: "url(#color-1)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 13,
    r: 9,
    fill: "url(#color-2)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarker);
export default __webpack_public_path__ + "static/media/marker.e1b418611b999807075d9c8248460e5a.svg";
export { ForwardRef as ReactComponent };